import { FabricObject, util } from 'fabric';

import { makeColorizedUrlForObject } from './makeColorizedUrlForObject';

interface SerializedImage {
  type?: string;
  src?: string;
  imageColor?: string;
}

/** Load the actual Fabric images before replacing an infographic's visible canvas. */
export async function prepareCanvasImages(objects: SerializedImage[]) {
  const images = objects.filter((object) => object.type?.toLowerCase() === 'image');
  for (const object of images) {
    if (object.imageColor && object.src?.includes('{color}')) {
      await makeColorizedUrlForObject(object, object.imageColor);
    }
  }
  // Fabric disposes objects already created in this batch if any image fails to load.
  const loaded = await util.enlivenObjects<FabricObject>(images);
  return new Map<object, FabricObject>(images.map((object, index) => [object, loaded[index]]));
}
